export default "__VITE_ASSET__BuQ7LWJ7__"